import { render } from "./ElemExam.vue?vue&type=template&id=21c7e158&scoped=true"
import script from "./ElemExam.vue?vue&type=script&lang=js"
export * from "./ElemExam.vue?vue&type=script&lang=js"

import "./ElemExam.vue?vue&type=style&index=0&id=21c7e158&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c7e158"]])

export default __exports__